import { manageSubscriptionsStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import { css } from "styled-components";

Object.assign(manageSubscriptionsStyles, {
    ...manageSubscriptionsStyles,
    manageSubscriptionsTitle: {
        variant: "h2",
        as: "h2",
        css: css`
            width: 100%;
            font-size: 22px;
            padding-bottom: 2px;
            margin: 0;
            color: #252525;
            border-bottom: none;
            text-transform: none;
        `,
    },
});
